'use strict';

var $ = require('lc-jquery');

function Footnotes(container) {
  this.$container = typeof container === 'string' ? $(container) : container;
  this.updateFootnotes();
}

Footnotes.prototype.updateFootnotes = function updateFootnotes() {
  // get all footnote sup tags on page, not just the ones in a given container,
  // since we need all of them to have any idea on how to order them
  var $sups = $('sup[data-footnote]');
  var $ul = this.$container.find('[data-footnotes-list]');
  var classes = $ul.attr('class') || '';
  var $ol = $('<ol>').addClass(classes);
  var footnoteNumbers = {};
  var footnoteContents = {};
  var counter = 1;

  $sups.each(function(index) {
    var $sup = $(this); // jQuery `this`
    var name = $sup.data('footnote');
    var $note;

    if (!footnoteNumbers.hasOwnProperty(name)) {
      footnoteNumbers[name] = counter;
      $note = $ul.find('[data-footnote-item=' + name + ']').clone();
      $note
        // jquery's use of .data() only changes the value in memory, it does not
        // override the literal data-xxx attribute in the DOM. we want both done.
        .data('footnote-item', footnoteNumbers[name])
        .attr('data-footnote-item', footnoteNumbers[name])
        .find('a')
          .attr('name', 'footnote-' + footnoteNumbers[name]);
      footnoteContents[name] = $note;
      counter++;
    }

    // replace asterisk in favor of number. may be a newly incremented
    // number or a previously stored value
    $sup
      .text(footnoteNumbers[name])
      .data('footnote', footnoteNumbers[name])
      .attr('data-footnote', footnoteNumbers[name]);
  });

  // now that we have all contents (de-duped for numbers that repeat)
  // create an OL out of them
  Object.keys(footnoteContents).forEach(function(name) {
    var $content = footnoteContents[name];
    $ol.append($content);
  });

  // replace the unordered list with the ordered one
  $ul.replaceWith($ol);
};

module.exports = Footnotes;

